module.exports = __webpack_public_path__ + "519d66e26090e9696535b26b97ba5152.MP3";